import { MutableRefObject, RefObject } from 'react';
import { useInViewport } from 'ahooks';
import { useAppSelector } from 'src/store';

const useLoadMore = (target: MutableRefObject<any> | RefObject<any>) => {
  const [isInViewPort] = useInViewport(target);
  const pagination = useAppSelector((state) => state.ui.app.pagination);

  const hasLoadMore =
    pagination.current_page < pagination.total_pages || pagination.next_page;

  return {
    nextPage: pagination.next_page || 0,
    hasLoadMore: !!hasLoadMore,
    isInViewPort: !!isInViewPort,
  };
};

export default useLoadMore;
